<section class="detail-section card" [class.is-collapsed]="collapsible && collapsed"
         [attr.data-testid]="testId || null">
    <header *ngIf="!bare" class="detail-section-header"
            [class.is-toggle]="collapsible"
            (click)="onToggle()">
        <i *ngIf="collapsible" class="fa detail-section-chevron"
           [class.fa-chevron-right]="collapsed"
           [class.fa-chevron-down]="!collapsed"></i>
        <i *ngIf="iconClass" class="fa detail-section-icon" [ngClass]="iconClass"></i>
        <div class="detail-section-titles">
            <h2 *ngIf="title" class="detail-section-title">{{ title }}</h2>
            <p *ngIf="description" class="detail-section-desc">{{ description }}</p>
        </div>
        <div class="detail-section-actions" (click)="$event.stopPropagation()">
            <ng-content select="[detailSectionHeaderActions]"></ng-content>
        </div>
    </header>

    <div class="detail-section-body" *ngIf="!collapsible || !collapsed">
        <ng-container [ngSwitch]="state">
            <div *ngSwitchCase="'loading'" class="detail-section-loading">
                <div class="skeleton-bar"></div>
                <div class="skeleton-bar narrow"></div>
                <div class="skeleton-bar"></div>
            </div>

            <div *ngSwitchCase="'empty'" class="detail-section-empty">
                <i class="fa fa-inbox"></i> {{ emptyMessage }}
            </div>

            <div *ngSwitchCase="'error'" class="detail-section-error">
                <i class="fa fa-exclamation-circle"></i> {{ errorMessage }}
            </div>

            <ng-container *ngSwitchDefault>
                <ng-content></ng-content>
            </ng-container>
        </ng-container>
    </div>
</section>
